export default __webpack_public_path__ + "static/media/nazzal.c2eddbf5.jpg";